import { CostosPlataformaService } from "../../generated/grpc/plataforma_costos_pb";
import { CostoAspersionResponse } from "../../response/costos/CostoAspersionResponse";
import { CostoAspersionPayload } from "../api/payload/costos/CostoAspersionPayload";
import { ServiceSaveBase } from "../base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../grpc/grpcCall";
import { CostoAspersionListService, toCostoAspersionResponse } from "./CostoAspersionListService";

/** Alta y edición de categorías de PROTEC; el resultado reemplaza la fila del listado. */
export class CostoAspersionSaveService extends ServiceSaveBase<CostoAspersionResponse, CostoAspersionPayload> {
  static readonly instance = new CostoAspersionSaveService();
  private constructor() { super(); }

  protected readonly cache = CostoAspersionListService.instance;

  /** gRPC-Web (`GuardarAspersion`): reemplaza los cultivos de la categoría; rechaza cultivos repetidos. */
  protected async sendSave(p: CostoAspersionPayload): Promise<CostoAspersionResponse> {
    const t = await grpcCall(() => grpcClient(CostosPlataformaService).guardarAspersion({
      id: p.id ?? undefined,
      categoria: p.categoria,
      precioPorHa: BigInt(p.precioPorHa),
      orden: p.orden,
      cultivoIds: p.cultivoIds,
    }));
    return toCostoAspersionResponse(t);
  }
}
